export enum ApplicationTheme {
  LIGHT = 0,
  DARK = 1,
  SYSTEM = 2,
}
